import React, {useContext, useEffect, useState} from 'react';
import {ReportState} from "../data/otherThoughtsData";
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import Button from "@mui/material/Button";
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import {UserContext} from "../context";
import axios from "axios";
import {backendURL} from "../assets/constants";
import {Spinner} from "react-bootstrap";

// const StyledButton = styled(Button)(({ theme }) => ({
//     '&:hover': {
//         fontSize: "16px",
//         color: purple[700]
//     }
// }));

const OtherThoughts = ({steps, activeStep}) => {
    const user = useContext(UserContext);
    const isOfflineUser = Boolean(user?.isOfflineUser);
    const userId = user?._id;
    const currentStep = steps[activeStep];
    const stepId = currentStep?.q_id;
    const [currentData, setCurrentData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!stepId) {
            return;
        }
        if (isOfflineUser || !userId) {
            setCurrentData([]);
            setLoading(false);
            return;
        }
        const fetchData = async () => {
            setLoading(true);
            let answers = [];
            try {
                let response = await axios.get(`${backendURL}/getAnswersForQuestion?user_id=${userId}&q_id=${stepId}`);
                if (response && response.data) {
                    answers = response.data;
                }
                // console.log("After answers: ", answers);
                let relatableAnswerIds = [];
                response = await axios.get(`${backendURL}/getUserRelatableAnswers?user_id=${userId}&q_id=${stepId}`);
                if (response && response.data) {
                    relatableAnswerIds = response.data;
                }
                // console.log("Relatable Answer Ids: ", relatableAnswerIds);
                const newData = answers?.map((item) => {
                    return {
                        answer_id: item._id,
                        label: item.answer,
                        relatable: relatableAnswerIds.includes(item._id),
                        reported: ReportState.NORMAL
                    };
                });
                setCurrentData(newData);
            } catch (e) {
                console.error(e);
            }
            finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [stepId, isOfflineUser, userId]);

    const toggleRelate = async (item, index) => {
        const newItem = {...item, relatable: !item.relatable};
        const newData = [...currentData];
        newData[index] = newItem;
        setCurrentData(newData);
        if (isOfflineUser || !userId) {
            return;
        }
        try {
            await axios.post(`${backendURL}/relateAnAnswer`, {
                user_id: userId,
                answer_id: item.answer_id,
                q_id: stepId,
                action: newItem.relatable ? 'RELATE' : 'UNRELATE'
            });
        } catch (error) {
            console.error('Failed to update relate reaction.', error);
        }
    };

    const getNextReportState = (state) => {
        switch (state) {
            case ReportState.NORMAL:
                return ReportState.INTERMEDIATE;
            case ReportState.INTERMEDIATE:
                return ReportState.REPORTED;
            default:
                return state;
        }
    };

    const getPreviousReportState = (state) => {
        switch (state) {
            case ReportState.INTERMEDIATE:
                return ReportState.NORMAL;
            default:
                return state;
        }
    };

    const changeReportView = async (item, index, direction = +1) => {
        const newItem = {
            ...item,
            reported: direction > 0 ? getNextReportState(item.reported) : getPreviousReportState(item.reported)
        };
        const newData = [...currentData];
        newData[index] = newItem;
        if (newItem.reported === ReportState.REPORTED && !isOfflineUser && userId) {
            try {
                await axios.post(`${backendURL}/reportAnswer`, {
                    user_id: userId,
                    answer_id: item.answer_id,
                    q_id: stepId
                });
            } catch (error) {
                console.error('Failed to report answer.', error);
            }
        }
        setCurrentData(newData);
    };

    const getReportedView = (item, index) => {
        if (item.reported === ReportState.INTERMEDIATE) {
            return <div style={{display: "flex", width: "100%", flexDirection: "column"}}>
                <em>"{item.label}"</em>
                <br/>
                <div>
                    <Button variant="contained" color="error" onClick={() => changeReportView(item, index, +1)}>Yes,
                        This comment is inappropriate</Button>
                </div>
                <br/>
                <div>
                    <Button variant="contained" onClick={() => changeReportView(item, index, -1)}>Nevermind</Button>
                </div>
            </div>;
        } else if (item.reported === ReportState.REPORTED) {
            return <div style={{width: "100%"}}>
                <span>Thank you for letting us know!</span>
            </div>;
        } else if (item.reported === ReportState.NORMAL) {
            return <>
                <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                    {/*<p style={{fontSize: "18px", textWrap: "wrap", textAlign: "left"}}>*/}
                    {/*    {currentStep.question}*/}
                    {/*</p>*/}
                    <span style={{
                        fontSize: "16px",
                        textAlign: "left",
                        textWrap: "wrap",
                        paddingRight: "20px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        fontWeight: "500"
                    }}>{item.label}</span>
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    marginLeft: "20px",
                    textWrap: "nowrap",
                    justifyContent: "space-between"
                }}>
                    {/*<StyledButton onClick={() => toggleRelate(item, index)}*/}
                    {/*              startIcon={item.relatable ? <FavoriteOutlinedIcon/> :*/}
                    {/*                  <FavoriteBorderOutlinedIcon/>}> I relate*/}
                    {/*</StyledButton>*/}

                    <button className="relateButton" onClick={() => toggleRelate(item, index)}>
                        {item.relatable ?
                            <FavoriteOutlinedIcon sx={{fontSize: '20px', marginBottom: "2px"}}/> :
                            <FavoriteBorderOutlinedIcon
                                sx={{fontSize: '20px', marginBottom: "2px", marginRight: "5px"}}/>
                        } <span className={item.relatable ? "relateButtonTextRelated" : "relateButtonTextNormal"}>I RELATE</span>
                    </button>

                    <button className="reportButton" onClick={() => changeReportView(item, index)}>
                        <ReportOutlinedIcon sx={{fontSize: '20px', marginBottom: "2px", marginRight: "5px"}}/>
                        <span className="relateButtonTextNormal">REPORT</span>
                    </button>

                    {/*<StyledButton onClick={() => changeReportView(item, index)} startIcon={<ReportOutlinedIcon/>}> Report</StyledButton>*/}
                </div>
            </>;
        }
    };

    return (
        <div style={{marginBottom: "150px"}}>
            <h1>What Others Answered:</h1>
            {isOfflineUser && (
                <p style={{marginTop: "20px"}}>Unable to load community answers while offline.</p>
            )}
            {
                loading ? (
                        <div style={{display: "flex", marginTop: "50px", justifyContent: "center"}}>
                            <Spinner color="#00BFFF" size={100}/>
                        </div>)
                    :
                    currentData.map((item, index) => {
                        return <div key={index} className="blue-box-other-thoughts shadow-sm"
                                    style={{
                                        width: "900px",
                                        marginTop: "20px",
                                        display: "flex",
                                        justifyContent: "space-between"
                                    }}>
                            {item && getReportedView(item, index)}
                        </div>
                    })
            }
        </div>

    );
};

export default OtherThoughts;
